import { safeParseInt } from './safeParseInt'

/**
 * @typedef {import('../index').Character} Character
 * @typedef {import('../index').AttributeType} AttributeType
 */

/**
 * @param {Array<number | 'series'>} bookIds
 * @param {Array<Character>} characters
 * @return {boolean}
 */
export const showBookTabs = (bookIds, characters) => {
  const aCharacterHasABook = characters.some((character) => {
    return character.bookIds && character.bookIds.length > 0
  })

  return bookIds.length > 1 && aCharacterHasABook
}

/**
 * @param {number} characterId
 * @param {number | 'all'} bookId
 * @param {{ templateId: String | Null, attributeName: String | Null, attributeId: String | Null | Number, type: String | Null }} arg
 * @return {['unknown'] | ['character', number, 'template', String, String, number | 'all'] | ['character', number, 'customAttribute', number | String, number | 'all'] | ['character', number, 'name'] }
 */
export const characterFocusPath = (
  characterId,
  bookId,
  { templateId, attributeName, attributeId, type }
) => {
  const parsedAttributeId = attributeId !== null ? safeParseInt(attributeId) : null
  // NOTE(ed): old tests expect the function to produce ['unknown']
  // when supplied with an invalid characterId.  I'm maintaining that
  // feature in case it somehow happens in production.
  if (typeof characterId !== 'number') {
    return ['unknown']
  } else if (!bookId || (typeof bookId !== 'number' && `${bookId}` !== bookId)) {
    return ['unknown']
  } else if (
    typeof templateId === 'string' &&
    typeof attributeName === 'string' &&
    (typeof bookId === 'number' || bookId === 'all')
  ) {
    return ['character', characterId, 'template', templateId, attributeName, bookId]
  } else if (
    parsedAttributeId !== null &&
    attributeId &&
    (attributeId === parsedAttributeId || `${parsedAttributeId}` === attributeId) &&
    (typeof bookId === 'number' || bookId === 'all')
  ) {
    return ['character', characterId, 'customAttribute', parsedAttributeId, bookId]
  } else if (type === 'name') {
    return ['character', characterId, type]
  } else if (typeof attributeId === 'string' && (typeof bookId === 'number' || bookId === 'all')) {
    return ['character', characterId, 'customAttribute', attributeId, bookId]
  } else {
    return ['unknown']
  }
}
